"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const SvgSprite_vue_1 = __importDefault(require("./SvgSprite.vue"));
exports.default = (0, vue_1.defineComponent)({
    __name: 'ButtonIcon',
    props: {
        iconClass: {
            type: String,
            default: 'text-button',
        },
    },
    setup(__props) {
        const props = __props;
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(SvgSprite_vue_1.default, {
                href: "icon-arrow-cert",
                class: (0, vue_2.normalizeClass)(["mr-1 md:mr-5 w-5 h-5 md:w-[30px] md:h-[30px] transition-colors icon-color-button flex-shrink-0", __props.iconClass])
            }, null, 8, ["class"]));
        };
    }
});
